import { useEffect, useState } from "react";
import { tg } from "./telegram";
import { api, loadToken, setToken, type UserOut } from "./api";
import { ClientHomeScreen } from "./screens/ClientHomeScreen";

export function DriverApp() {
  const [user, setUser] = useState<UserOut | null>(null);
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const w = tg();

    (async () => {
      const existing = loadToken();
      if (existing) {
        try {
          const me = await api.me();
          if (!active) return;
          if (me.role === "client") {
            setUser(me);
            return;
          }
          setToken(null);
        } catch {
          if (!active) return;
          setToken(null);
        }
      }
      const initData = w?.initData;
      if (!initData) {
        setAuthError("Telegram Mini App ichida ochilishi kerak.");
        return;
      }
      try {
        const res = await api.authTelegram(initData);
        if (!active) return;
        setToken(res.access_token);
        setUser(res.user);
      } catch (e) {
        if (!active) return;
        const err = e as { message?: string; code?: string };
        setAuthError(err.message || err.code || "Avtorizatsiya muvaffaqiyatsiz");
      }
    })();

    return () => { active = false; };
  }, []);

  if (authError) {
    return (
      <div className="app">
        <div className="empty">{authError}</div>
      </div>
    );
  }
  if (!user) {
    return (
      <div className="app">
        <div className="center">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  // Mini App'ni ochgan har bir foydalanuvchi shaxsiy garajga ega bo'ladi
  // (ustaxonaga bog'liq emas). Auth har doim mijoz (self) sifatida kiradi.
  // Ekran shellini (header + pastki navigatsiya) ClientHomeScreen boshqaradi.
  return <ClientHomeScreen user={user} />;
}
